module.exports = __webpack_public_path__ + "media/goforajourney/img/goforajourney-logo-h-13f26721ca38a2bb653a6fe848b3c887.png";